import Input from "../../components/input";
import Button from "../../components/button";
import { Table } from "../../components/ui/table";
import SortIcon from "../../components/icons/sort-icon";
import { useEffect, useState } from "react";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import CardDetail from "../../components/cardDetail/cardDetail";
import {
  getTransactionHistory,
  getTransectionHistoryCount,
} from "src/firebase/admin.js";
import Loader from "../../components/loader";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import { exportToExcel } from "react-json-to-excel";
import { useTranslation } from "react-i18next";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";
import Select from "../../components/select/select";
import { doc, setDoc } from "firebase/firestore";
import { db } from "src/firebase/firebase";

var pageSize = 200;

const payoutOption = [
  { value: "pending", label: "Pending" },
  { value: "sent", label: "Sent" },
  { value: "canceled", label: "Canceled" },
];

const TransactionHistory = () => {
  const [activeDeletedId, setActiveDeletedId] = useState<string>("");
  const [activeCardId, setActiveCardId] = useState<string>("");
  const [transectionHistory, setTransectionHistory] = useState([]);
  const [filterTransectionHistory, setFilterTransectionHistory] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [calenderValue, setCalenderValue] = useState(null);
  const [isShowCalender, setIsShowCalender] = useState<boolean>(false);
  const [totalCards, setTotalCards] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");
  const { t } = useTranslation(["home"]);
  useEffect(() => {
    getTransectionList();
  }, [currentPage, searchText]);

  useEffect(() => {
    getTransectionListCount();
  }, []);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const getTransectionListCount = async () => {
    let result = await getTransectionHistoryCount();
    setTotalCards(result);
  };

  const getTransectionList = async () => {
    pageSize=200;
    setIsLoading(true);
    const filter:any = {
      start: '',
      end: ''
    }
    let result = await getTransactionHistory(
      currentPage,
      searchText ? 50 : pageSize,
      searchText,
      "",
      "cardNo",
      filter
    );

    setIsLoading(false);
    setTransectionHistory(result ?? []);
    setFilterTransectionHistory(result ?? []);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handlePayoutStatus = async (value: any, data: any) => {
    console.log(value, data);
    const _data = {
      ...data,
      payoutStatus: value,
    };
    await setDoc(doc(db, "Cards", data.id), _data);
    getTransectionList();
  };
  const columns = [
    // {
    //   title: (
    //     <div className="pl-1 flex justify-between items-center">
    //       <span>{t("ID")}</span>
    //     </div>
    //   ),
    //   dataIndex: "id",
    //   key: "id",
    //   width: 200,
    // },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("User Name")}</span>
        </div>
      ),
      dataIndex: "userName",
      render: (userName: string, row: any) => (
        <div>{`${row.account.firstName} ${row.account.lastName}`}</div>
      ),
      key: "userName",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Card No")}</span>
        </div>
      ),
      dataIndex: "cardNo",
      key: "cardNo",
      width: 200,
      render: (cardNo: string) => <div>{cardNo}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Cvv")}</span>
        </div>
      ),
      dataIndex: "cvv",
      key: "cvv",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("MM/YY")}</span>
        </div>
      ),
      dataIndex: "mmyy",
      key: "mmyy",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Amount")}</span>
        </div>
      ),
      dataIndex: "amount",
      key: "amount",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Rate")}</span>
        </div>
      ),
      dataIndex: "rate",
      key: "rate",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Order")}</span>
        </div>
      ),
      dataIndex: "order",
      key: "order",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Status")}</span>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (status: string) => (
        <div>
          {status === "pending activation" && (
            <span className="py-1 px-3 bg-warn text-warn-700 rounded inline-block w-[100px] text-center ">
              {t("Pending activation")}
            </span>
          )}
          {status === "pending" && (
            <span className="py-1 px-3 bg-warn text-warn-700 rounded inline-block w-[70px] text-center ">
              {t("Pending")}
            </span>
          )}
          {status === "paid" && (
            <span className="py-1 px-3 bg-success-100 text-success rounded inline-block w-[70px] text-center ">
              {t("Paid")}
            </span>
          )}
          {status === "declined" && (
            <span className="py-1 px-3 bg-red-100 text-red rounded inline-block text-center w-[70px]">
              {t("Declined")}
            </span>
          )}
        </div>
      ),
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Payout Status")}</span>
        </div>
      ),
      dataIndex: "payoutStatus",
      key: "payoutStatus",
      width: 200,
      render: (payoutStatus: any, row: any) => {
        let _payoutStatus = payoutStatus || "pending";
        return (
          <div>
            <Select
              placeholder="Select payout status"
              options={payoutOption}
              value={
                payoutOption.find(
                  (item: any) => item.value === _payoutStatus
                ) ?? null
              }
              onChange={(value: any) => handlePayoutStatus(value.value, row)}
            />
          </div>
        );
      },
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")}</span>
        </div>
      ),
      dataIndex: "transectionDate",
      key: "transectionDate",
      render: (date: any) => (
        <div>
          {date ? moment(date.seconds * 1000).format("YYYY MM,DD, HH:mm") : ""}
        </div>
      ),
      width: 200,
    },
  ];

  const handleExportData = () => {
    const _data = filterTransectionHistory.map((item) => ({
      Time: item.transectionDate
        ? moment(item.transectionDate.seconds * 1000).format("MMMM/DD, HH:mm")
        : "",
      Supplier: item?.account?.firstName + " " + item?.account?.lastName,
      Amount: item?.amount,
      Order: item?.order,
      Rate: item?.rate,
      cardNo: item?.cardNo,
    }));
    exportToExcel(_data, "transactionHistory");
  };

  const handleCalenderChange =  async (value) => {
    setCalenderValue(value);
    // console.log(value)

    setIsLoading(true);

    const filter:any = {
      start: value[0].getTime(),
      end: value[1].getTime()
    }
    pageSize=1000;
    let result = await getTransactionHistory(
      currentPage,
      searchText ? 50 : pageSize,
      searchText,
      "",
      "",
      filter
    );

    setIsLoading(false);
    setTransectionHistory(result ?? []);
    setFilterTransectionHistory(result ?? []);

    // const _data = transectionHistory.filter((item) =>
    //   item?.transectionDate
    //     ? new Date(item.transectionDate.seconds * 1000).getTime() >=
    //         value[0].getTime() &&
    //       new Date(item.transectionDate.seconds * 1000).getTime() <=
    //         value[1].getTime()
    //     : false
    // );
    // setFilterTransectionHistory([..._data]);
    setIsShowCalender((prev) => !prev);
  };

  console.log("setCalenderValue", calenderValue);
  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Transactions History")}
        </h2>
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-bold ">
            {t("Transactions")}{" "}
          </h1>
          <div className="flex gap-2 items-center">
            <div className="relative">
              {calenderValue &&
                calenderValue.map((item, index) => (
                  <span className="font-sm font-bold mr-2">
                    {moment(item).format("LL")}{" "}
                    {index !== calenderValue.length - 1 ? "-" : ""}
                  </span>
                ))}
              <Button
                className="h-[35px]"
                onClick={() => setIsShowCalender((prev) => !prev)}
              >
                {t("Calender filter")}
              </Button>
              {isShowCalender && (
                <div className="absolute top-[40px] z-10">
                  <Calendar
                    selectRange={true}
                    value={calenderValue}
                    onChange={handleCalenderChange}
                  />
                </div>
              )}
            </div>
            <Button className="h-[35px]" onClick={handleExportData}>
              {t("Export CSV")}
            </Button>

            <Input
              name="keyword"
              placeholder={t("Search by keyword")}
              inputClassName="h-9"
              variant="solid"
              onChange={(e) => handleSearch(e.target.value)}
            />

            <Button
              className="h-[35px] bg-transparent !border !border-blue !text-blue"
              onClick={() => {
                setCalenderValue(null);
                getTransectionList();
              }}
            >
              {t("Clear")}
            </Button>
          </div>
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText="No data found"
          data={filterTransectionHistory}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        {!searchText && !calenderValue && (
          <Pagination
            className="w-full mt-10"
            page={currentPage}
            count={Math.ceil(totalCards / pageSize)}
            onChange={handlePageChange}
          />
        )}
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId("")}
      >
        <ConfirmationCard
          title="Delete This Item?"
          onCancel={() => setActiveDeletedId("")}
          onDelete={() => {}}
          description="Are you sure about deleting this card? This cannot be undone."
        />
      </Modal>
      <Modal
        open={activeCardId ? true : false}
        onClose={() => setActiveCardId("")}
        modalClass="w-full"
      >
        <CardDetail />
      </Modal>
    </div>
  );
};
export default TransactionHistory;
